<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">Ajuste Documentación</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="`/accreditationtechnical/setting-information/documents/store`"
      >
        
     <div>
      <p class="my-4">{{filename}}:</p>
      <app-input
        type="file"
        v-model="inputs.file_1"
        id="file_1"
        :label="
          inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')
        "
        :required="true"
      />
     </div>

      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosGet } from "@/app/helpers/AxiosHelper";

export default {
  name: "SettingDocModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    dataId: Number,
    accApp:Object,
    filename: String,
    filetype: String,
  },
  data() {
    return {
      preloader: false,
      modalId: "setting-doc-modal",
      inputs: {},
      parents: {},
    };
  },
  created() {
    
  },
  methods: {
    submit() {
      this.inputs.data_id = this.dataId;
      this.inputs.file_type = this.filetype;
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      this.$hub.$emit("reload-" + this.tableId);
      //this.$toastr.s(this.$t("created_success"));
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
  },
};
</script>

<style>
</style>
